import { createStyles } from 'antd-style';

import { ThemeColors } from '../../theme';

export const useStickyElementStyles = createStyles(({ css, cx }) => {
  const stickyElementInner = cx(css({}));
  const stickyElementContent = cx(
    css({
      position: 'relative',
      zIndex: 1,
    })
  );

  return {
    stickyElementInner,
    stickyElementContent,
    stickyElement: {
      [`&.active > .${stickyElementInner}`]: {
        position: 'fixed',
        zIndex: 1,
        backgroundColor: ThemeColors.COLOR_WHITE2,

        // This is so that shadows of the scroll content from below are covered
        // by the background-like shadow
        '&::before, &::after': {
          content: '" "',
          position: 'absolute',
          height: '100%',
          top: 0,
          width: 10,
        },
        '&::before': {
          boxShadow: `inset -10px 0 0 10px ${ThemeColors.COLOR_WHITE2}`,
          left: -10,
        },
        '&::after': {
          boxShadow: `inset 10px 0 0 10px ${ThemeColors.COLOR_WHITE2}`,
          right: -10,
        },
      },
    },
  };
});
